// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#app {\n  padding-bottom: 20px;\n}\n.main-container {\n  max-width: 800px; /* Adjust this value as needed */\n  margin: 0 auto; /* Center the container */\n  padding: 20px; /* Add some padding for spacing */\n  /* Add any other global styles you want to apply across pages */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
